<div class="card">
  <div class="card-content phd-page">
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label" for="phd-manager">Manager</label>
          <p-select
            id="phd-manager"
            [(ngModel)]="selectedManager"
            (ngModelChange)="onFilterChange()"
            [options]="managerOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="phd-client">Client</label>
          <p-select
            id="phd-client"
            [(ngModel)]="selectedClient"
            (ngModelChange)="onFilterChange()"
            [options]="clientOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="phd-sg">Service group</label>
          <p-select
            id="phd-sg"
            [(ngModel)]="selectedServiceGroup"
            (ngModelChange)="onFilterChange()"
            [options]="serviceGroupOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="phd-status">Status</label>
          <p-select
            id="phd-status"
            [(ngModel)]="selectedStatus"
            (ngModelChange)="onFilterChange()"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
      </div>

      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button
          type="button"
          class="btn-clear-filters"
          (click)="clearFilters()"
          title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <div class="stats-cards-row phd-kpi-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-label">Milestones this month</span>
          <span class="stats-card-value phd-kpi-value phd-kpi-value--info">{{ milestonesThisMonth }}</span>
          <span class="stats-card-sublabel">{{ milestonesThisMonthSub }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-flag"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-label">Completed on time</span>
          <span class="stats-card-value phd-kpi-value phd-kpi-value--success">{{ completedOnTime }}</span>
          <span class="stats-card-sublabel">{{ completedOnTimeSub }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-label">Milestones at risk</span>
          <span class="stats-card-value phd-kpi-value phd-kpi-value--warning">{{ atRiskCount }}</span>
          <span class="stats-card-sublabel">{{ atRiskSub }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-exclamation-triangle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-label">Overdue milestones</span>
          <span class="stats-card-value phd-kpi-value phd-kpi-value--danger">{{ overdueCount }}</span>
          <span class="stats-card-sublabel">{{ overdueSub }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-times-circle"></i></div>
      </div>
    </div>

    <section class="phd-panel phd-panel--timeline">
      <header class="phd-panel-header">
        <h3 class="phd-panel-title">
          Delivery timeline — planned vs actual ({{ timelineYear }})
          <!-- The panel shows at most INITIAL_TIMELINE_LIMIT projects; say so
               explicitly rather than silently truncating the list. -->
          <span class="phd-panel-count" *ngIf="visibleTimelineRows.length">
            · showing {{ visibleTimelineRows.length }}
            {{ visibleTimelineRows.length === 1 ? 'project' : 'projects' }}
          </span>
        </h3>
        <p class="phd-panel-legend" aria-hidden="true">
          <span class="phd-legend-item"><span class="phd-swatch phd-swatch--completed"></span> Completed</span>
          <span class="phd-legend-item"><span class="phd-swatch phd-swatch--planned"></span> Planned</span>
          <span class="phd-legend-item"><span class="phd-swatch phd-swatch--behind"></span> Behind</span>
        </p>
      </header>
      <!-- Month header sits OUTSIDE .phd-chart-wrap: it is a fixed column ruler for
           the rows, so it must not scroll with them. position:sticky inside the
           scroller did not hold because the container's own padding-top offsets
           where top:0 resolves to. -->
      @if (visibleTimelineRows.length > 0) {
        <div class="timeline-month-header">
          @for (month of monthLabels; track month) {
            <span>{{ month }}</span>
          }
        </div>
      }
      <div class="phd-chart-wrap">
        @if (visibleTimelineRows.length > 0) {
          <div class="timeline-rows">
            @for (row of visibleTimelineRows; track row.projectCode + row.projectLabel) {
              <div class="timeline-row">
                <div class="timeline-row-label">{{ row.projectLabel }}</div>
                <div class="timeline-row-track">
                  <span class="timeline-segment timeline-segment--completed" [style.width.%]="timelineSegmentWidth(row.completedMonths)"></span>
                  <span class="timeline-segment timeline-segment--planned" [style.width.%]="timelineSegmentWidth(row.plannedMonths)"></span>
                  <span class="timeline-segment timeline-segment--behind" [style.width.%]="timelineSegmentWidth(row.behindMonths)"></span>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="phd-chart-empty">No projects match the current filters.</div>
        }
      </div>
    </section>

    <div class="phd-tables-grid">
      <section class="phd-panel">
        <header class="phd-panel-header phd-panel-header--compact">
          <h3 class="phd-panel-title">Upcoming milestones — next 30 days</h3>
        </header>
        <div class="phd-table-shell">
          <p-table
            [value]="upcomingRows"
            [tableStyle]="{ 'min-width': '100%' }"
            [scrollable]="true"
            scrollHeight="360px"
            styleClass="p-datatable no-column-lines compact-striped-table phd-table table-no-xscroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Project</th>
                <th>Milestone</th>
                <th>Due date</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td class="phd-cell-project">{{ row.projectLabel }}</td>
                <td>{{ row.milestone }}</td>
                <td>{{ row.dueDateLabel }}</td>
                <td>
                  <span [class]="statusBadgeClass(row.milestoneStatus)">{{ statusLabel(row.milestoneStatus) }}</span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="table-empty-row table-empty-row--compact">
                <td colspan="4" class="table-empty-cell">
                  <div class="empty-state empty-state--compact">
                    <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                    <p class="empty-message">No upcoming milestones in view.</p>
                    <p class="empty-description">Adjust or clear the filters to see more</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </section>

      <section class="phd-panel">
        <header class="phd-panel-header phd-panel-header--compact">
          <h3 class="phd-panel-title">Planned vs actual completion</h3>
        </header>
        <div class="phd-table-shell">
          <p-table
            [value]="completionRows"
            [tableStyle]="{ 'min-width': '100%' }"
            [scrollable]="true"
            scrollHeight="360px"
            styleClass="p-datatable no-column-lines compact-striped-table phd-table table-no-xscroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Project</th>
                <th class="phd-th-narrow">Planned</th>
                <th class="phd-th-narrow">Actual</th>
                <th class="phd-th-narrow">Variance</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td class="phd-cell-project">{{ row.projectLabel }}</td>
                <td>{{ row.plannedPct }}%</td>
                <td>{{ row.actualPct }}%</td>
                <td>
                  <span [class]="varianceBadgeClass(row.variancePct)">{{ varianceLabel(row.variancePct) }}</span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="table-empty-row table-empty-row--compact">
                <td colspan="4" class="table-empty-cell">
                  <div class="empty-state empty-state--compact">
                    <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                    <p class="empty-message">No completion data in view.</p>
                    <p class="empty-description">Adjust or clear the filters to see more</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </section>
    </div>
  </div>
</div>
